import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Alert,
} from '@mui/material';

import { useGenerateOfferBoardingPlaceMutation } from '../Service/extendedOfferBoardingPlacesApi';
import { AutomaticOfferBoardingPlaceDialogProps } from './AutomaticOfferBoardingPlaceDialogTypes';

const AutomaticOfferBoardingPlaceDialog = ({
  offerId,
  open,
  onClose,
  onSuccess,
}: AutomaticOfferBoardingPlaceDialogProps) => {
  const [generateOfferBoardingPlace, { isLoading, isError, error }] =
    useGenerateOfferBoardingPlaceMutation();
  const [totalPlaces, setTotalPlaces] = useState<number | ''>('');

  const handleGenerate = async () => {
    const n = typeof totalPlaces === 'string' ? parseInt(totalPlaces) : totalPlaces;
    if (!n || n < 1) {
      alert('Podaj liczbę przystanków większą od zera!');
      return;
    }
    const boardingPlaces = Array.from({ length: n }, () => ({
      city: 'wpisz nazwę miasta',
      stop: 'wpisz nazwę przystanku',
      time: '00:00',
      price: 0,
    }));
    const payload = {
      offerId,
      customPlaces: boardingPlaces,
    };

    await generateOfferBoardingPlace(payload).unwrap();
    onClose();
    if (onSuccess) onSuccess();
    //else navigate(OffersRoutes.root);
  };

  const handleClose = () => {
    setTotalPlaces('');
    onClose();
    if (onSuccess) onSuccess();
    //else navigate(OffersRoutes.root);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Stwórz miejsca wsiadania</DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <TextField
            label="Ilość przystanków"
            type="number"
            value={totalPlaces}
            onChange={(e) => setTotalPlaces(e.target.value === '' ? '' : Number(e.target.value))}
            inputProps={{ min: 1, max: 30 }}
            fullWidth
            autoFocus
          />
        </Box>
        {isError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {(error as any)?.data?.message || 'Nie udało się utworzyć miejsc wsiadania.'}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Anuluj
        </Button>
        <Button
          onClick={handleGenerate}
          variant="contained"
          color="primary"
          disabled={isLoading || !totalPlaces || Number(totalPlaces) < 1}
        >
          Wygeneruj
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AutomaticOfferBoardingPlaceDialog;
